module.exports = __webpack_public_path__ + "static/img/mobile-web-img@w.021c93e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos/mobile-web-img@w.png
// module id = ov6y
// module chunks = 0